
import { defineComponent, ref, getCurrentInstance, onActivated, computed } from 'vue';
import Search from 'vant/lib/search';
import { sendLog } from '@/common/radar';

const ProfileIconCdnUrl = 'https://cdn-static.kwai.net/kos/s101/nlav11312/pwa-images/default-head.png';
const BomdiaLogo = 'https://cdn-static.kwai.net/kos/s101/nlav11312/pwa-images/bom_dia_logo.png';
const SnackLogo = 'https://cdn-static.kwai.net/kos/s101/nlav11312/pwa-images/snack_logo.png';
const KwaiLogo = 'https://cdn-static.kwai.net/kos/s101/nlav11312/pwa-images/kwai_logo.png';

export default defineComponent({
    components: {
        Search,
    },
    props: {
        currentUserHeadUrl: {
            type: String,
            default: ProfileIconCdnUrl,
        },
        hideSearch: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['onClickAvatarBtn', 'onClickSearchBtn'],
    setup(_: unknown, { emit }) {
        const { proxy } = getCurrentInstance() || {};
        const searchText = ref('');
        const showAvatar = ref(true);

        const handleLogoClick = () => {
            sendLog({
                type: 'click',
                name: 'MOBILE_TOP_CLICK_AREA',
                value: {
                    button_type: 'logo',
                },
            });

            proxy?.$router?.push({ path: '/foryou', query: { page_source: 'search' } });
        };

        const onClickAvatarBtn = () => {
            sendLog({
                type: 'click',
                name: 'MOBILE_TOP_CLICK_AREA',
                value: {
                    button_type: 'avatar',
                },
            });

            emit('onClickAvatarBtn');
        };

        const onClickSearchBtn = () => {
            sendLog({
                type: 'click',
                name: 'MOBILE_TOP_CLICK_AREA',
                value: {
                    button_type: 'research',
                },
            });

            emit('onClickSearchBtn', searchText.value ?? '');
        };

        const handleFocus = () => {
            showAvatar.value = false;
        };

        onActivated(() => {
            searchText.value = proxy?.$route?.params?.content?.replace(/(-)/g, ' ') || '';
        });

        const logoCDNUrl = computed(() => {
            // 临时使用host判断是否新app，为了审核
            // 后续优化
            if (proxy?.$store?.state?.host?.includes('kwai.film')) {
                return BomdiaLogo;
            }
            if (proxy?.$isSnack) {
                return SnackLogo;
            }
            return KwaiLogo;
        });

        return {
            searchText,
            showAvatar,
            ProfileIconCdnUrl,
            logoCDNUrl,

            handleLogoClick,
            onClickAvatarBtn,
            handleFocus,
            onClickSearchBtn,
        };
    },
});
